module.exports = __webpack_public_path__ + "static/5-b5904bc45185eb29491513a0fb7c9ac8.jpg";